import { TweenParticleLookupModel } from '../story/models/tween-particle-lookup.model';

type OldChapterId = string;
type NewChapterId = string;

declare const Human;

export namespace TweenParticleLookup {
  /**
   * Replace the chapterIds of the lookup with the new chapter Ids.
   * Needed whenever we don't serialize 'in place', like when we save a new bookmark in studio.
   *
   * e.g.
   * chapter_abc --> chapter_def
   *
   * `{chapter_abc: {particleId: string}}`
   * becomes
   * `{chapter_def: {particleId: string}}`
   *
   */
  export function updateChapterIds(
    currentLookup: TweenParticleLookupModel,
    newChapterMap: Record<OldChapterId, NewChapterId>
  ): TweenParticleLookupModel {
    const oldChapterIds = Object.keys(currentLookup);

    const newLookup = oldChapterIds.reduce((acc, oldChapterId) => {
      const newChapterId = newChapterMap[oldChapterId];
      acc[newChapterId] = currentLookup[oldChapterId];
      return acc;
    }, {});

    return newLookup;
  }

  export function duplicateChapter(
    originChapterId: string,
    duplicateChapterId: string,
    lookup: TweenParticleLookupModel
  ): TweenParticleLookupModel {
    const newLookup = {
      ...lookup,
      [duplicateChapterId]: lookup[originChapterId],
    };
    return newLookup;
  }

  export function deleteChapter(
    chapterId: string,
    lookup: TweenParticleLookupModel
  ): TweenParticleLookupModel {
    const newLookup = { ...lookup };
    delete newLookup[chapterId];
    return newLookup;
  }

  export function addEntryForChapter(
    chapterId: string,
    entry: Record<string, string>,
    lookup: TweenParticleLookupModel
  ) {
    lookup[chapterId] = {...lookup[chapterId], ...entry};
    return lookup;
  }

  export function refreshEngineLookup(
    moduleId: string,
    lookup: TweenParticleLookupModel
  ) {
    Human.modules.moduleData[moduleId].tweenParticleLookup = lookup;
  }
}
